export default __webpack_public_path__ + "static/media/ic_list_bulleted_white.f39aff3d.svg";